import MSCartesian from '@fusioncharts/charts/src/chart/_internal/mscartesian';
import MultiSeriesManager from '@fusioncharts/charts/src/dataset/groups/column-multiseries';
import ErrorBar2DDataset from '../../dataset/errorbar2d';

const ERRORBAR_2D = 'errorbar2d';
class ErrorBar2D extends MSCartesian {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'ErrorBar2D';
  }

  constructor () {
    super();
    this.showValues = 0;
    this.isErrorChart = true;
    // this.fireGroupEvent = true;
    this.eiMethods = { };
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'ErrorBar2D';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.hasLegend = true;
    config.defaultDatasetType = ERRORBAR_2D;
    config.enablemousetracking = true;
  }
  getDSGroupdef () {
    return MultiSeriesManager;
  }
  getDSdef () {
    return ErrorBar2DDataset;
  }
}
export default ErrorBar2D;
